import { StandaloneArticleFooter, StandaloneArticleFooterProps } from '@/components/ArticleFooter';
import { LabradorComponent, StandaloneComponent } from '@/types/component';
import { withDebugMetadata } from 'lib/utils';
import mergeProps from 'lib/utils/mergeProps';

export const HantStandaloneArticleFooter: StandaloneComponent<StandaloneArticleFooterProps> = (props) => {
  return (
    <StandaloneArticleFooter
      {...mergeProps(
        {
          options: {
            $tag: {
              options: {
                size: 'medium',
              },
            },
          },
        },
        props
      )}
    />
  );
};

export const standalone = HantStandaloneArticleFooter;

const HantLabradorArticleFooter: LabradorComponent = ({ type, data, meta, descendants }) => {
  return <HantStandaloneArticleFooter tags={data.tags} options={data.options} {...withDebugMetadata({ type, meta })} />;
};

export default HantLabradorArticleFooter;
